import { DocumentAnnotationElement } from '@st/document-components/annotations'
import { Viewport } from '@st/document-rendering'
import type { ComponentProps } from 'react'

type Props = Pick<ComponentProps<typeof DocumentAnnotationElement>, 'annotation'>

export function DocumentAnnotationDisplay({ annotation }: Props) {
  return (
    <Viewport width={annotation.bounds.width} height={annotation.bounds.height}>
      <DocumentAnnotationElement annotation={annotation} />
    </Viewport>
  )
}
